import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=16a465bc&"
import script from "./headline.ts?vue&type=script&lang=ts&"
export * from "./headline.ts?vue&type=script&lang=ts&"
import style0 from "./headline.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports